import BackButton from "../common/navigation/BackButton";
import Button from "../common/F7/Button";
import ListBlock from "../common/F7/ListBlock";
import ListBlockItem from "../common/F7/ListBlockItem";
import Page from "../common/navigation/Page";
import React, { FC } from "react";
import Spinner from "../common/F7/Spinner";
import { Link } from "react-router-dom";
import usePermissions from "../../hooks/usePermissions";
import { useCurrentProject } from "../../hooks/database/useCurrentProject";

const ProjectPage: FC = () => {
  const { canAddInventory, canOpenProjectSettings } = usePermissions();

  const { data: project, loading } = useCurrentProject();

  if (!project && !loading) {
    return (
      <Page navbarLeft={<BackButton />} title="Unknown project">
        Unknown project
      </Page>
    );
  } else if (!project) {
    return <Spinner />;
  }

  return (
    <Page
      navbarLeft={<BackButton />}
      navbarRight={
        canOpenProjectSettings ? (
          <Link to="edit">
            <i
              className="fa fa-cog"
              style={{
                fontSize: 25,
                padding: 10,
                cursor: "pointer",
              }}
            />
          </Link>
        ) : null
      }
      title={project.name}
    >
      <ListBlock title="Inventories">
        {Object.entries(project.inventories || {}).map(([key, object]) => (
          <ListBlockItem key={key} title={object.name} to={`../../../i/${key}`} />
        ))}
      </ListBlock>
      {canAddInventory ? <Button to="i/new">Add Inventory</Button> : null}
    </Page>
  );
};
export default ProjectPage;
